
import { importSync as i } from '@embroider/macros';
let d = window.define;
d("ember-resize-observer-service/services/resize-observer", function(){ return i("ember-resize-observer-service/services/resize-observer");});
d("ember-resize-observer-service/utils/ignore-ro-error", function(){ return i("ember-resize-observer-service/utils/ignore-ro-error");});
import "ember-modifier/-embroider-implicit-modules.js";
import "ember-auto-import/-embroider-implicit-modules.js";
import "ember-cli-htmlbars/-embroider-implicit-modules.js";
import "ember-resize-observer-service/-embroider-implicit-modules.js";
